import React from "react";
import {
  formatDueDate,
  getDueDateStatus,
} from "../../../app/utils/projectBoard/boardDesignTokens";
import BoardBadge from "../BoardBadge/BoardBadge";
import "./BoardDueDate.scss";

const BoardDueDate = ({ dueDate, showIcon = true, className = "" }) => {
  if (!dueDate) return null;

  const status = getDueDateStatus(dueDate);
  const label = formatDueDate(dueDate);

  const variantMap = {
    overdue: "overdue",
    "due-soon": "due-soon",
    normal: "default",
    none: "default",
  };

  return (
    <BoardBadge
      variant={variantMap[status]}
      icon={showIcon ? "🕐" : null}
      className={className}
      title={new Date(dueDate).toLocaleString()}
    >
      {label}
    </BoardBadge>
  );
};

export default BoardDueDate;
